(function() {
    var supportTouch = $.support.touch,
        scrollEvent = "touchmove scroll",
        touchStartEvent = supportTouch ? "touchstart" : "mousedown",
        touchStopEvent = supportTouch ? "touchend" : "mouseup",
        touchMoveEvent = supportTouch ? "touchmove" : "mousemove";
    $.event.special.swipeupdown = {
      setup: function() {
        var thisObject = this;
        var $this = $(thisObject);
        $this.bind(touchStartEvent, function(event) {
          var data = event.originalEvent.touches ?
            event.originalEvent.touches[ 0 ] :
            event,
            start = {
                time: (new Date).getTime(),
                coords: [ data.pageX, data.pageY ],
                origin: $(event.target)
            },
            stop;

          function moveHandler(event) {
              if (!start) {
                  return;
              }
              var data = event.originalEvent.touches ?
                      event.originalEvent.touches[ 0 ] :
                      event;
              stop = {
                  time: (new Date).getTime(),
                  coords: [ data.pageX, data.pageY ]
              };

              // prevent scrolling
              if (Math.abs(start.coords[1] - stop.coords[1]) > 10) {
                  event.preventDefault();
              }
          }
          $this
            .bind(touchMoveEvent, moveHandler)
            .one(touchStopEvent, function(event) {
              $this.unbind(touchMoveEvent, moveHandler);
              if (start && stop) {
                if (stop.time - start.time < 1000 &&
                  Math.abs(start.coords[1] - stop.coords[1]) > 30 &&
                  Math.abs(start.coords[0] - stop.coords[0]) < 75) {
                    start.origin
                    .trigger("swipeupdown")
                    .trigger(start.coords[1] > stop.coords[1] ? "swipeup" : "swipedown");
                }
              }
            start = stop = undefined;
          });
        });
      }
    };
    $.each({
      swipedown: "swipeupdown",
      swipeup: "swipeupdown"
    }, function(event, sourceEvent){
      $.event.special[event] = {
        setup: function(){
          $(this).bind(sourceEvent, $.noop);
        }
      };
    });

})();

var w, h;

const t = 700;

var $win    = $(window),
    $body   = $('body'),
    $header = $('.header'),
    $footer = $('.footer');

var $nav = {
    menus    : $('.menu-inner'),
    menu     : $('.menu'),
    mlink    : $('.menu-link.mobile-menu-link'),
    logo     : $('svg.header-logo path'),
    link     : $('.menu-link'),
    controls : $('.control-link'),
    dlink    : $('.menu-link.desktop-menu-link'),
    close    : $('.menu-close'),
    dclose   : $('.menu-desktop-close'),
    item     : $('.menu-item'),
    label    : $('.menu-label'),
    drop     : $('.menu-item-container'),
    brand    : $('.brand-column-menu li'),
    image    : $('.brand-image'),
    brands   : $('.brand-column-menu'),
};

var _global = {
  elem: function() {
    if ($('.error-404').length) {
      var res = (w >= 1024) ? 'desktop' : 'mobile';
      $('.error-404').css({
        'background': 'url(' + $('.error-404').data(res) + ') center no-repeat',
        'background-size': 'cover',
      });
    }
  },

  init: function() {
    $header.removeClass('off');

    $body.removeClass('initializing');

    setTimeout(function() {
      $body.removeClass('switch');
    }, 2000);
  },

  lazy: function() {
    $nav.brand.each(function() {
      $('<img/>')[0].src = $(this).data('image');
    });
  },

  isEmptyObject: function(obj) {
    for(var prop in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        return false;
      }
    }
    return true;
  },

  rand: function(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);

    return Math.floor(Math.random() * (max - min)) + min;
  },

  res: function() {
    w = $win.width();
    h = $win.height();

    if ($('.grid-product-image-container').length) {
      $('.grid-product-image-container').height($('.grid-product-image-container').width() * .9);
    }
  },

  email: function(email) {
    pattern = /^[A-Z0-9._%+-]+@([A-Z0-9-]+\.)+[A-Z]{2,12}$/i;
    return pattern.test(email);
  },
};

var _nav = {
  inFooter  : false,
  lastPos   : $(document).scrollTop(),
  direction : 'down',
  dirLength : 0,
  threshold : 30,

  check: function() {
    _nav.inFooter = $(document).scrollTop() >= $(document).height() - $footer.height() - _nav.threshold;

    if (_nav.inFooter) {
      _nav.color(innerColor.text, innerColor.logo);
    } else {
      _nav.color(outerColor.text, outerColor.logo);
    }

    var newDir = $(document).scrollTop() > _nav.lastPos ? 'down' : 'up';
    if (newDir == _nav.direction) {
      _nav.dirLength++;
    } else {
      _nav.dirLength = 0;
    }

    if ($(document).scrollTop() > _nav.lastPos && !_nav.inFooter) {
      if (_nav.dirLength >= _nav.threshold) {
        $header.addClass('off');
        $('.product-header').removeClass('header-active');
      }
    } else {
      if (_nav.dirLength >= _nav.threshold || $(document).scrollTop() < 80) {
        $header.removeClass('off');
        $('.product-header').addClass('header-active');
      }
    }

    _nav.direction  = newDir;
    _nav.lastPos    = $(document).scrollTop();
  },

  color: function(items, logo) {
    if (items) {
      logo = logo ? logo : items;
    } else {
      items = outerColor.text;
      logo  = outerColor.logo;
    }

    $nav.link.css('color', items);
    $nav.logo.css('fill', logo);
    // Set the colour directly on the header every time the slideshow updates.
    // The switcher uses this same value, without depending on slide DOM observers.
    if ($header.length && items) {
      $header[0].style.setProperty('--csm-nav-text-color', items);
    }
  },

  mount: function(section) {
    $header.addClass('active');
    _nav.color(innerColor.text, innerColor.logo);
    $nav.close.removeClass('inactive').fadeIn(t);
    $nav.menu.fadeIn(t);
    $nav.controls.fadeOut(0);
    $body.addClass('scroll-lock');

    $(".ly-custom-1000").hide();
    $(".ly-custom-0").hide();

    if (typeof section !== 'undefined') {
      _nav.section(section);
    }
  },

  section: function(section) {
    setTimeout(function() { 
      $('.menu-item:not([data-menu="' + section + '"])').removeClass('active');
      $('.menu-item[data-menu="' + section + '"]').addClass('active');
      if (w >= 768) setTimeout(function() {
        $('.menu-item[data-menu="' + section + '"] .menu-item-container').fadeIn(t);
      }, 50)
    }, 500);
  },

  unmount: function() {
    $header.removeClass('active');
    if (!_nav.inFooter) {
      _nav.color(outerColor.text, outerColor.logo);
    } else {
      if (_nav.inFooter) {
        _nav.color(innerColor.text, innerColor.logo);
      } else {
        _nav.color(outerColor.text, outerColor.logo);
      }
    }
    $nav.menu.fadeOut(t);
    $nav.controls.css('display', 'inline-block');
    $nav.close.addClass('inactive').delay(t).fadeOut(0);
    setTimeout(function() {
      $nav.item.removeClass('active');
      $nav.controls.removeClass('inactive')
      $nav.dlink.removeClass('active inactive');
    }, t);

    if (!bodyLock) $body.removeClass('scroll-lock');
    $(".ly-custom-1000").show();
    $(".ly-custom-0").show();
  },
};

var $select = {
  container : $('.pseudo-select'),
  active    : $('.select-active'),
  input     : $('.pseudo-select-input'),
  option    : $('.select-option'),
};

$select.active.click(function() {
  var select = $(this).data('select');
  $('.pseudo-select[data-select="' + select + '"]').addClass('active');
});

$select.option.click(function() {
  var option = $(this).data('option');
  var select = $(this).data('select');

  $('.select-option[data-select="' + select + '"], .pseudo-select[data-select="' + select + '"]').removeClass('active');
  $(this).addClass('active');

  $('.pseudo-select-input[data-select="' + select + '"]').val(option);
  $('.select-active-label[data-select="' + select + '"]').text(option);
});

$select.container.hover(function() {
  $(this).addClass('active');
}, function() {
  $(this).removeClass('active');
});

var $newsletter = {
  mc : {
    input   : $('#mce-EMAIL'),
    submit  : $('#mc-embedded-subscribe'),
    form    : $('#mc-embedded-subscribe-form'),
  },
  footer: {
    input       : $('#footer-newsletter-input'),
    form        : $('#footer-newsletter-form'),
    error       : $('#footer-newsletter-form .error'),
    entry       : $('#footer-newsletter-form .form-entry'),
    successful  : $('#footer-newsletter-form .form-success'),
  },
};

var _newsletter = {
  signups: [],

  check: function(email) {
    var valid   = _global.email(email);
    var unique  = ($.inArray(email, _newsletter.signups) == -1);
    if (valid && unique) {
      return true;
    } else {
      if (!valid) {
        $newsletter.footer.error.text('Please enter a valid email. Mettez une adresse email valide.');
        return false;
      }

      if (!unique) {
        $newsletter.footer.error.text('This email has already been entered. Cette adresse e-mail est déjà envoyée.');
        return false;
      }
    }
  },

  dispatch: function(email) {
    var action = $newsletter.mc.form.attr('action');
    $.ajax({
      type: 'post',
      url: action, 
      data: {
        EMAIL: email
      },
      dataType: 'jsonp',
    }).success(function(data) {
      console.log('success', data);
      _newsletter.successful(email);
    }).error(function(data) {
      console.log('error', data);
      if (data.statusText == 'success') {
        _newsletter.successful(email);
      }
    });

  },

  submit: function(email) {
    email = email || $newsletter.footer.input.val();
    if (_newsletter.check(email)) {
      $newsletter.footer.error.removeClass('active');
      $newsletter.footer.form.removeClass('error-invalid');

      _newsletter.dispatch(email);
    } else {
      $newsletter.footer.error.addClass('active');
      $newsletter.footer.form.addClass('error-invalid');
    }
  },

  successful: function(email) {
    $newsletter.footer.form.addClass('success');
    $newsletter.footer.entry.fadeOut(t);
    $newsletter.footer.successful.delay(t + 50).fadeIn(t);
    _newsletter.signups.push(email);

    setTimeout(function() {
      $newsletter.footer.input.val('').removeAttr('value');
      $newsletter.footer.form.removeClass('success');
      $newsletter.footer.successful.fadeOut(t);
      $newsletter.footer.entry.delay(t + 50).fadeIn(t);
    }, 8000);
  }
};

$newsletter.footer.form.on('submit', function(e) {
  e.preventDefault();
  _newsletter.submit();
});

$nav.label.click(function() {
  $(this).parent().toggleClass('active');
});

$nav.mlink.click(function() {
  _nav.mount();
});

$nav.close.click(function() {
  _nav.unmount();
});

$nav.dclose.click(function() {
  _nav.unmount();
});

$nav.dlink.click(function() {
  if ($(this).data('menu') == 'brands' || $(this).data('menu') == 'shop') {
    if ($(this).hasClass('active')) {
      _nav.unmount();
    } else {
      if (w >= 768) $('.menu-item-container').fadeOut(500);
      $nav.dlink.removeClass('active').addClass('inactive');
      $nav.controls.addClass('inactive');
      $(this).addClass('active');
      _nav.mount($(this).data('menu'));
    }
  }
});

$nav.brand.on('mouseenter', function() {
  if (w > 1024) {
    $nav.image.addClass('active');
    $nav.brand.addClass('inactive').removeClass('active');
    $(this).addClass('active').removeClass('inactive');
    var color = ($(this).data('color')) ? $(this).data('color') : 'rgb(' + _global.rand(0, 200) + ',' + _global.rand(0, 200) + ',' + _global.rand(0, 200) + ')'; 
    var image = ($(this).data('image')) ? $(this).data('image') : $nav.menu.data('image');

    $nav.image.append('<img class="queued-image" src="' + image + '" />');
    $('.brand-image .current-image').removeClass('current-image').addClass('destroy-image');
    
    $nav.menu.css('background', color);
    setTimeout(function() {
      $('.brand-image .queued-image').removeClass('queued-image').addClass('current-image');
    }, 0);

    setTimeout(function() {
      $('.brand-image .destroy-image').remove();
    }, t);
  }
});

$nav.brands.on('mouseleave', function() {
  $nav.menu.css('background', innerColor.bg);
  if (w > 1024) {
    $nav.brand.removeClass('active inactive');
    $nav.image.removeClass('active');
  }
});

$(document).ready(function() {
  _global.res();
  _global.elem();
  _nav.check();
});

$win.resize(function() {
  _global.res();
});

$win.on('load', function() {
  _global.init();
  _global.lazy();
});

$win.on('scroll', function() {
  _nav.check();
});

$(window).bind('pageshow', function(event) {
  if (event.originalEvent.persisted) {
    window.location.reload() 
  }
});


var redirectLocation = null;
$(document).on('click', 'a', function(e) {
  // Same-page fit guide anchors must not trigger the global page transition.
  var href = $(this).attr('href');
  if (href && href.charAt(0) === '#') {
    var target = document.getElementById(href.substring(1));
    if (target) {
      e.preventDefault();
      if (target.tagName.toLowerCase() === 'details') target.open = true;
      var offset = target.getBoundingClientRect().top + window.pageYOffset - 95;
      window.scrollTo({ top: Math.max(0, offset), behavior: 'smooth' });
      if (window.history && window.history.replaceState) window.history.replaceState(null, '', href);
      return;
    }
  }
  if (href && $(this).attr('target') !== '_blank') {
    e.preventDefault();
    redirectLocation = $(this).attr('href');
    $header.addClass('off');
    $body.addClass('switch initializing');

    setTimeout(function() {
      window.location.href = redirectLocation;
    }, 1000);
  }
});

var $account = {
  recover: {
    link    : $('#RecoverPassword'),
    form    : $('#RecoverPasswordForm'),
    success : $('.recover-success'),
  },
};

var _account = {
  init: function() {
    if (window.location.hash == '#recover') _account.recover();
    if (window.location.hash == '#recovered') $account.recover.success.fadeIn(t);
  },

  recover: function() {
    $account.recover.form.fadeIn(t);
    $('html, body').animate({ scrollTop: $account.recover.link.offset().top }, 1000);
  }
};

$account.recover.link.click(function() {
  _account.recover(); 
});

$(document).ready(function() {
  if (csm.template.indexOf('customers') !== -1) _account.init();
});
var $cart = {
  count : $('.item-count'),
  remove: $('.item-remove'),
  update: $('#update-cart'),
};

var _cart = {
  remove: function(variant) {
    $('#update_' + variant).val(0);
    $cart.update.trigger('click');
  },

  update: function() {
    $.getJSON('/cart.js', function(data) {
      if (data.item_count) $cart.count.addClass('active').text('(' + data.item_count + ')')
    });
  },
};

$cart.remove.click(function() {
  _cart.remove($(this).data('variant'));
});

$(document).ready(function() {
  _cart.update();
});
var $collection = {
  container   : $('.collection-container'),
  description : $('.collection-description'),
  scroll      : $('.collection-desktop-scroll'),
  filter      : $('.collection-filter button'),
  grid        : $('.product-grid'),
  products    : $('.grid-product'),
  images      : $('.grid-product-images'),
  clear       : $('.clear-filters'),
  hero        : $('.collection-hero'),
  clearH      : $('.collection-filter .clear-filters'),
  clearO      : $('.filter-overlay .clear-filters'),
  options     : $('.filter-options'),
  index       : $('.filter-carousel-index-point'),
};

$collection.scroll.click(function() {
  $('html, body').animate({ scrollTop: h }, 1000);
});

var _collection = {
  activate: function(type) {
    $('.filter-type').removeClass('active');
    $('.filter-type[data-type="' + type + '"]').addClass('active');
    $('.filter-type-options').removeClass('active');
    $('.filter-type-options[data-type="' + type + '"]').addClass('active');
  },

  init: function() {
    _collection.nav();
    _collection.size();
    if ($collection.description.find('p').length > 1) {
      $collection.description.addClass('has-more');
      $collection.description.find('p').eq(0).addClass('first-description');
    } else if ($collection.description.find('p').length == 0) {
      var content = '<p>' + $collection.description.html() + '</p>';
      $collection.description.html(content);
    }
    $filter.logo.width($('.header-logo').width());
  },

  less: function() {
    $('.collection-description p:not(:first-of-type)').fadeOut(t);
  },

  more: function() {
    $('.collection-description p:not(:first-of-type)').fadeIn(t);
  },

  nav: function() {
    if (!_nav.inFooter &&
        typeof collectionTextColor !== 'undefined') {

      _nav.color(outerColor.text, outerColor.logo);
    } else {
      _nav.color();
    }
  },

  size: function() {
    var tallest = 0;
    $collection.images.each(function() {
      var iH = $(this).find('.grid-product-image-container').eq(0).height();
      if (iH > tallest) {
        $collection.images.height(iH);
        tallest = iH;
      }
    });
  }
};

var $filter = {
  overlay : $('.filter'),
  logo    : $('.filter-logo'),
  close   : $('.filter-close'),
  types   : $('.filter-types'),
  options : $('.filter-options'),
  apply   : $('.filter-apply'),
};

var _selection = {
  brands: [],
  colors: [],
  sizes: [],
  types: [],
};

var _options = {
  brands: {},
  colors: {},
  sizes: {},
  types: {},
};

var _filters = {
  types: [],
  sizes: [],
  colors: [],
  brands: [],
};

var _filter = {
  calibrate:  0,
  queries:    [],
  subqueries: [],

  prefix: ($collection.container.data('collection')) ? 'collection_id=' + $collection.container.data('collection') + '&' : '',

  apply: function() {

    var apply = {
      types:  [],
      sizes:  [],
      colors: [],
      brands: [],
    };

    if ($('.filter-option.active').length) {
      $('.filter-option.active').each(function() {
        var option  = (typeof $(this).data('option') == 'string') ? $(this).data('option').toLowerCase() : $(this).data('option');
        //option      = ($(this).data('type') == 'sizes' || $(this).data('type') == 'colors') ? option : option.replace(/ /g, '%20');
        apply[$(this).data('type')].push(option);
      });
    } else {
      location.reload();
    }

    _filter.buttons(apply);
    _filter.fetch(apply);

    _collection.size();
    $('html, body').animate({ scrollTop: $collection.hero.innerHeight() }, 1000);
    _collection.size();
  },

  buttons: function(apply) {
    for (var key in apply) {
      var count = (apply[key].length) ? '(' + apply[key].length + ')' : '';
      $('.filter-button[data-type="' + key + '"] .filter-count').html(count);
    }
  },

  checkOptions: function() {
    var available   = {};
    var unavailable = {};
    for (key in _selection) {
      _selection[key].forEach(function(val) {
        $('.filter-option').each(function() {
          var type    = $(this).data('type');
          var option  = $(this).data('option');
          var newKey  = type + '|' + option;
          if ($.inArray(option, _options[key][val]) == -1 &&
              option  !== val &&
              type    !== key) {
            $(this).addClass('unavailable');
            unavailable[newKey] = $(this);
          } else if (type !== key) {
            $(this).addClass('available');
            available[newKey] = $(this);
          }
        })
      });
    }

    $('.filter-option.available, .filter-option.active').removeClass('inactive available unavailable');
    $('.filter-option.unavailable').addClass('inactive').removeClass('unavailable');
  },

  collect: function() {
    $collection.products.each(function() {
      var product = {
        brands  : ($(this).data('brands'))  ? $(this).data('brands').split('|') : [],
        colors  : ($(this).data('colors'))  ? $(this).data('colors').split('|') : [],
        sizes   : ($(this).data('sizes'))   ? $(this).data('sizes').split('|') : [],
        types   : ($(this).data('types'))   ? $(this).data('types').split('|') : [],
      };

      for (var key in product) {
        var tmpKey = [];
        product[key].forEach(function(value) {
          var val     = (typeof value == 'string' && key !== 'brands') ? value.trim().toLowerCase() : value.trim();
          var option  = key + '|' + val;

          if (val) {
            if  ((key !== 'colors' || $.inArray(val, tmpKey) >= 0) &&
                $.inArray(val, _filters[key]) == -1 &&
                (key !== 'colors' || val.length <= 14)) _filters[key].push(val);

            var newOption = [];
            for (var k in product) {
              if (k !== key) {
                product[k].forEach(function(cell) {
                  cell = (typeof cell == 'string' && key !== 'brands') ? cell.trim().toLowerCase() : cell.trim();
                  if (cell && $.inArray(cell, newOption) == -1) newOption.push(cell);
                });
              }
            }

            _options[key][val] = (val in _options[key]) ? _options[key][val].concat(newOption) : newOption;
          }

          tmpKey.push(val);
        });
      }
    });

    for (var key in _filters) if (key !== 'sizes') _filters[key].sort();
  },

  clean: function() {
    $('.filter-type-options').each(function() {
      if ($(this).find('.filter-option').length <= 1) {
        var type = $(this).data('type');
        $('.filter-type[data-type="' + type + '"]').remove();
        $('.filter-type-options[data-type="' + type + '"]').remove();
        $('.filter-button[data-type="' + type + '"]').remove();
      }

      if ($('.filter-button').length < 1) {
        $('.collection-filter, .filter').remove();
      }
    });
  },

  create: function() {
    for (var key in _filters) {
      $filter.options.append('<div class="filter-type-options" data-type="' + key + '"></div>');
      _filters.sizes.sort();
      _filters[key].forEach(function(val) {
        if (val.trim()) {
          if (key == 'sizes') {
            if (isNaN(parseInt(val))) {
              // Tops size
              if (val) {
                if (!$('.filter-subtype[data-subtype="tops"]').length) $('.filter-type-options[data-type="' + key + '"]').append('<div class="filter-subtype" data-subtype="tops"></div>');
                $('.filter-subtype[data-subtype="tops"]').append('<button class="tag filter-option" data-type="' + key + '" data-option="' + val + '">' + val + ' +</button>');
              }
            } else if (parseInt(val) > 26) {
              // Pants size
              if (!$('.filter-subtype[data-subtype="pants"]').length) $('.filter-type-options[data-type="' + key + '"]').append('<div class="filter-subtype" data-subtype="pants"></div>');
              $('.filter-subtype[data-subtype="pants"]').append('<button class="tag filter-option" data-type="' + key + '" data-option="' + val + '">' + val + '</button>');
            } else {
              // Shoes size
              if (!$('.filter-subtype[data-subtype="shoes"]').length) $('.filter-type-options[data-type="' + key + '"]').append('<div class="filter-subtype" data-subtype="shoes"></div>');
              $('.filter-subtype[data-subtype="shoes"]').append('<button class="tag filter-option" data-type="' + key + '" data-option="' + val + '">' + val + '</button>');
            }
          } else {
            $('.filter-type-options[data-type="' + key + '"]').append('<button class="tag filter-option" data-type="' + key + '" data-option="' + val + '">' + val + '</button>');
          }
        }
      });
    }

    var tops  = $('.filter-subtype[data-subtype="tops"]');
    var pants = $('.filter-subtype[data-subtype="pants"]');
    var shoes = $('.filter-subtype[data-subtype="shoes"]');
    $('.filter-type-options[data-type="sizes"]').empty().append(tops).append(pants).append(shoes);
  },

  fetch: function(apply) {
    _filter.queries     = [];
    _filter.subqueries  = [];
    for (var key in apply) {
      if (apply[key].length) {
        var q = _filter.getPrefix(key);

        if (key == 'colors' || key == 'sizes') {
          apply[key].forEach(function(val) {
            var query = q + '=' + val;
            if ($.inArray(query, _filter.subqueries) == -1) {
              _filter.subqueries.push(query);
            }
          });
        } else {
          apply[key].forEach(function(val) {
            var query = q + '=' + val;
            if ($.inArray(query, _filter.queries) == -1) {
              _filter.queries.push(query);
            }
          });
        }
      }
    }

    _filter.getProducts();
  },

  filterProducts: function() {
    if (_filter.queries.length) {
      var filtered = [];

      for (var i = 0; i < _filter.products.length; i++) {
        var product = _filter.products[i];

        for (var j = 0; j < _filter.queries.length; j++) {
          var request = _filter.queries[j].split('=');
          var base    = request[0];
          var target  = request[1];

          if (product[base].toLowerCase() == target) {
            filtered[product.id] = product;
          }
        }
      }
    
      _filter.products = filtered;
    }

 
    if (_filter.subqueries.length) {
      var filtered = [];

      for (var key in _filter.products) {
        var product = _filter.products[key];

        for (var j = 0; j < _filter.subqueries.length; j++) {
          var request = _filter.subqueries[j].split('=');
          var base    = request[0];
          var target  = request[1];

          for (var k = 0; k < product.options.length; k++) {
            if (product.options[k]['name'].toLowerCase() == base) {
              for (var l = 0; l < product.options[k]['values'].length; l++) {
                if (product.options[k]['values'][l].toLowerCase() == target) {
                  filtered[product.id] = product;
                }
              }
            }
          }
        }
      }

      _filter.products = filtered;

    }


    // populate grid
    _filter.grid(_filter.products);
  },

  getPrefix: function(key, val) {
    var q;
    switch (key) {
      case 'types':
        q = 'product_type';
        break;
      case 'brands':
        q = 'vendor';
        break;
      case 'colors':
        q = 'color';
        break;
      case 'sizes':
        q = 'size';
        break;
    }

    if (typeof val !== 'undefined' && val) q += '=' + val;
    return q;
  },

  getProducts: function() {
    var ajaxQuery = 'https://10a5541e912d2d3caa4566a4e0f556db:31f0ee45110f163f09cbfdb126bcb6e5@mercantile-mtl.myshopify.com/products.json?limit=250';

    $.ajax({
      type: 'GET',
      url: ajaxQuery,
      crossDomain: true,
      dataType: 'json',
      success: function(data) {
        _filter.products = data.products;

        // activate clear filter buttons
        $collection.clearH.addClass('active');
        setTimeout(function() {
          $collection.clearO.addClass('active');
        }, t*2);

        _filter.filterProducts();

        // order and reveal grid
        setTimeout(function() {
          _filter.unmount();
          _collection.size();
        }, 100);
      },
      error: function(data) {
        console.log('error:', data);
      }  
    });

  },

  getVariants: function(item) {
    var variants = {
      sizes:  [],
      colors: [],
    };

    for (var i = 0; i < item.variants.length; i++) {
      if (item.variants[i].option1) {
        var variant = item.variants[i].option1;
        variant     = (typeof variant == 'string') ? variant.toLowerCase() : variant;
        variants.sizes.push(variant);
      }
      if (item.variants[i].option2) {
        var variant = item.variants[i].option2;
        variant     = (typeof variant == 'string') ? variant.toLowerCase() : variant;
        variants.colors.push(variant);
      }
    }

    return variants;
  },

  grid: function(products) {
    $collection.grid.empty();

    if (!_global.isEmptyObject(products)) {
      for (var key in products) {
        $collection.grid.append(_filter.sanitize(products[key]));
        _collection.size();
      }
    } else {
      $collection.grid.append('<h1>0 results</h1>');
    }
    $collection.images = $('.grid-product-images');
    _collection.size();

    setTimeout(function() {
      _collection.size();
    }, t); 
  },

  init: function() {
    _filter.collect();
    _filter.create();
    _filter.clean();
  },

  mount: function() {
    $header.addClass('filter-active');
    $body.addClass('scroll-lock');
    $(".ly-custom-1000").hide();
    $(".ly-custom-0").hide();
    _nav.color(innerColor.text, innerColor.logo);
    setTimeout(function() {
      $filter.overlay.fadeIn(t);
      $nav.menus.fadeOut(t);

      if (!_filter.calibrate) {
        _filter.size();
      }
    }, 700);
  },

  sanitize: function(item) {
    var image     = '';
    var variants  = _filter.getVariants(item);

    for (var i = 0; i < 2; i++) {
      if (typeof item.images[i] !== 'undefined') {
        image += '<div class="grid-product-image-container"><img class="grid-product-image" src="' + item.images[i].src + '" /></div>';
      }
    }

    var images  = '<div class="grid-product-images">' + image + '</div>';
    var vendor  = '<span class="grid-product-collection">' + item.vendor + '</span>';
    var title   = '<span class="grid-product-title">' + item.title + '</span>';
    var compare = (item.variants[0].compare_at_price) ? '<span class="grid-product-compare">' + item.variants[0].compare_at_price + '</span>' : '';
    var price   = '<span class="grid-product-price">' + compare + '$' + item.variants[0].price;
    var inner   = images + vendor + title + price;

    var product = '<div class="grid-product"><a href="' + (Shopify.routes.root || '/').replace(/\/?$/, '/') + 'products/' + item.handle + '">' + inner + '</a></div>';
    return product;
  },

  size: function() {
    if (w > 768) {
      if ($('.slick-active').length) $collection.options.slick('unslick');
    } else {
      $('.filter-type-options').each(function() {
        $('.filter-carousel-index').append('<div class="filter-carousel-index-point carousel-index-point" data-carousel="filter"></div>');
      });
      $('.filter-carousel-index-point').eq(0).addClass('active');

      $collection.options.slick({
        adaptiveHeight: true,
        arrows : false,
      });
    }

    _filter.calibrate = 1;
  },

  unmount: function() {
    $filter.overlay.fadeOut(t);
    $nav.menus.fadeIn(t);
    $body.removeClass('scroll-lock');
    $(".ly-custom-1000").show();
    $(".ly-custom-0").show();
    _collection.size();
    setTimeout(function() {
      $header.removeClass('filter-active');
      _nav.color(outerColor.text, outerColor.logo);
    }, 700);
  },

};

$collection.description.click(function() {
  if ($(this).hasClass('more')) {
    _collection.less();
  } else {
    _collection.more();
  }
  $(this).toggleClass('more');
});

$collection.filter.click(function() {
  _filter.mount();
});

$filter.close.click(function() {
  _filter.unmount();
});

$(document).on('click', '.filter-option', function() {
  if (!$(this).hasClass('inactive')) {
    var $elem   = $(this);
    var type    = $elem.data('type');
    var option  = $elem.data('option');
    $elem.toggleClass('active');
    if ($elem.hasClass('active')) {
      _selection[type].push(option);
    } else {
      var index = _selection[type].indexOf(option);
      _selection[type].splice(index, 1);
    }
    _filter.checkOptions();
  }
});

$(document).on('click', '.filter-type, .filter-button, .mobile-filter', function() {
  if ($(this).data('type')) { 
    _collection.activate($(this).data('type'));

    if (w < 768) {
      $collection.options.slick('slickGoTo', $('.filter-type[data-type="' + $(this).data('type') + '"]').index('.filter-type'));
    }
  } else {
    _collection.activate($('.filter-type').eq(0).data('type'));
  }
});

$filter.apply.click(function() {
  _filter.apply();
});

$collection.clear.click(function() {
  location.reload();
});

$(document).on('click', '.filter-carousel-index-point', function() {
  var carousel  = $(this).data('carousel');
  var index     = $(this).index('.carousel-index[data-carousel="' + carousel + '"] .carousel-index-point');
  
  $collection.options.slick('slickGoTo', index);
});

$collection.options.on('beforeChange', function(event, slick, current, next) {
  $('.filter-carousel-index-point').removeClass('active').eq(next).addClass('active');
  _collection.activate($('.filter-type').eq(next).data('type'));
});


$(document).ready(function() {
  if (typeof collection !== 'undefined' && collection) {
    _collection.init();
    _filter.init();
  }
});

$(window).on('resize', function() {
  if (typeof collection !== 'undefined' && collection) {
    _collection.size();
  }
});

$(window).on('load', function() {
  if (typeof collection !== 'undefined' && collection) {
    _collection.size();
  }
});
var $slider = {
  container : $('.homepage-slider'),
  slides    : $('.slide'),
  progress  : $('.section-progress'),
  slider    : $('.section-slider'),
};

var scrollThrottle = 0,
    bodyLock       = 0,
    slideLock = false;

var _slider = {
  current: 0,
  slides: $slider.slides.length,

  nextSlide: function() {
    if (_slider.current !== $slider.slides.length - 1 && slideLock === false && !$header.hasClass('active')) {
      slideLock = true;
        
      $slider.slides.eq(_slider.current).removeClass('active').addClass('inactive');
      _slider.current++;
      $slider.slides.eq(_slider.current).addClass('active');

      outerColor = {
        text : $slider.slides.eq(_slider.current).data('text-color'),
        logo : $slider.slides.eq(_slider.current).data('logo-color') || $slider.slides.eq(_slider.current).data('text-color'),
      };

      _nav.color(outerColor.text, outerColor.logo);

      //scrollThrottle = 1;

      setTimeout(function() {
        //scrollThrottle = 0;
        slideLock = false;
      }, 1080);
      _slider.updateIndex();
    }
    
  },

  prevSlide: function() {
    if (_slider.current !== 0 && slideLock === false && !$header.hasClass('active')) {
        
        slideLock = true;
        
      $slider.slides.eq(_slider.current).removeClass('active');
      _slider.current--;
      $slider.slides.eq(_slider.current).removeClass('inactive').addClass('active');

      outerColor = {
        text : $slider.slides.eq(_slider.current).data('text-color'),
        logo : $slider.slides.eq(_slider.current).data('logo-color') || $slider.slides.eq(_slider.current).data('text-color'),
      };

      _nav.color(outerColor.text, outerColor.logo);

      //scrollThrottle = 1;

      setTimeout(function() {
        //scrollThrottle = 0;
          slideLock = false;
      }, 1080);
    _slider.updateIndex();
    }
  },

  updateIndex: function() {
    var progress = (_slider.current / (_slider.slides - 1)) * 100;
    $slider.progress.css('width', progress + '%');
  }
}

// homepage vertical swipe detection:
// -mobile gestures
/*$(document).on('swipeup', function() {
    
    if(slideLock === false){
        if ($slider.container.length) _slider.nextSlide();
    }
});
$(document).on('swipedown', function() {
  console.log('down');
    if(slideLock === false){
        if ($slider.container.length) _slider.prevSlide();
    }
});*/

var scrollReset   = 700,
    timeoutCheck  = false,
    timeoutScroll;

// event listener for scrolling
// this works even when $win.scrollTop is static
function scrollDetection() {
  $win.one('mousewheel DOMMouseScroll', function (e) {

    setTimeout(function() {
      var menuColor = document.querySelector(".menu-link:first-child").style.color;
      document.querySelector(".ly-custom-1000 a span").style.color = menuColor;
      document.querySelector(".ly-custom-1000 a:last-child span").style.color = menuColor;
      document.querySelector(".ly-custom-0 a span").style.color = menuColor;
      document.querySelector(".ly-custom-0 a:last-child span").style.color = menuColor;
    },200);

    var evt     = e.originalEvent || e;
    var deltaY  = evt.deltaY || (-1 / 40 * evt.wheelDelta) || evt.detail;

    setTimeout(function() {
      timeoutCheck  = false;
    }, scrollReset);
      
    if (deltaY > 0) {
      if ($slider.container.length && !slideLock && !timeoutCheck) {
        timeoutCheck = true;
        _slider.nextSlide();
      }
    } else {
      if ($slider.container.length && !slideLock && !timeoutCheck) {
        timeoutCheck = true;
        _slider.prevSlide();   
      }
    }
  });

  setTimeout(function() {
    scrollDetection();
  }, scrollReset);
}
scrollDetection();

var _slides = {
  check: function() {
    if (w <= 1024) homepageOverride();
  },

  init: function() {
    $body.css('overflow', 'hidden');
    _slides.size();

    outerColor = {
      text : $slider.slides.eq(_slider.current).data('text-color'),
      logo : $slider.slides.eq(_slider.current).data('logo-color') || $slider.slides.eq(_slider.current).data('text-color'),
    };

    _nav.color(outerColor.text, outerColor.logo);

    if (w <= 1024) {
      $win.on('scroll', function() {
        _slides.size();
      });
    }
  },

  size: function() {
    var orientation = (w > h) ? 'desktop-image' : 'mobile-image';
    $slider.slider.height(h);
    $slider.slides.each(function() {
      if (w > 1024) {
        $(this).height(h);
      } else {
        $(this).height(h);
      }


      var src   = $(this).data(orientation);
      var color = $(this).data('color');
      if ($(this).hasClass('image-full-width')) {
        if (src) {
          $(this).css({
            'background': 'url(' + src + ') no-repeat center',
            'background-size': 'cover',
          });
        }
      } else {
        if (w > h || !$(this).hasClass('image-slide')) {
          $(this).css('background', color);

          if (src) $(this).find('.slide-image').attr('src', src);
        } else {
          if (src) {
            $(this).css({
              'background': 'url(' + src + ') no-repeat center',
              'background-size': 'cover',
            });
          }
          $(this).find('.slide-image').addClass('inactive');
        }
      }
    });

    var csrc = $('.contact-image').data(orientation);
    $('.contact-image').height(h - $('.contact-info').outerHeight()).css({
      'background': 'url(' + csrc + ') no-repeat center',
      'background-size': 'cover',
    });;
  },
};

// binding arrow keys to slide navigation
$(document).keydown(function(e) {
  switch(e.which) {
    case 37: // left
    case 38: // up
      _slider.prevSlide();
    break;

    case 39: // right
    case 40: // down
      _slider.nextSlide();
    break;

    default: return; // exit for other keys
  }
  e.preventDefault();
});

$(document).ready(function() {
  if ($slider.container.length && csm.template == 'index') {
    $body.addClass('scroll-lock');
    $header.addClass('homepage');
    _slides.init();
    $slider.slides.eq(_slider.current).addClass('active');

    $('body').on('touchmove',function(e){
      let firstSwipe;
      if (!firstSwipe) _slider.nextSlide();
    }); 
  } else {
    $win.off('DOMMouseScroll mousewheel');
  }
  if ($slider.container.length) _slides.check();
});

$win.resize(function() {
  if ($slider.container.length) _slides.size();
});

$win.on('load', function() {
  var checkInt = setInterval(function() {
    if (!$body.hasClass('initializing')) {
      _slides.size();
      $('.homepage-slider').css({
        'display' : 'block',
        'opacity' : 0
      }).delay(t).animate({
        'opacity' : 1
      }, 1000);
      clearInterval(checkInt);
    }
  }, 100);
});

function homepageOverride() {
  $(document).bind('touchmove', function(e) {
    if (!$header.hasClass('active')) {
      e.preventDefault();
    }
  });
  document.addEventListener('touchstart', handleTouchStart, false);        
  document.addEventListener('touchmove', handleTouchMove, false);

  var xDown = null;                                                        
  var yDown = null;                                                        

  function handleTouchStart(evt) {     
    xDown = evt.touches[0].clientX;                                      
    yDown = evt.touches[0].clientY;                                      
  }                                      

  function handleTouchMove(evt) {
    if (!xDown || !yDown) {
      return;
    }
    var xUp = evt.touches[0].clientX;                                    
    var yUp = evt.touches[0].clientY;

    var xDiff = xDown - xUp;
    var yDiff = yDown - yUp;

    if (Math.abs(xDiff) > Math.abs(yDiff)) {
      if (xDiff > 0) {
        /* left swipe */ 
      } else {
        /* right swipe */
      }                       
    } else {
      if (yDiff > 0) {
        if (!slideLock) _slider.nextSlide();
      } else { 
        if (!slideLock) _slider.prevSlide();
      }                                                                 
    }
    
    /* reset values */
    xDown = null;
    yDown = null;                                             
  }
}
var $story = {
  tagline : $('.our-story-section .tagline'),
  brands  : $('.our-story-brands'),
  brand   : $('.our-story-brand'),
  press   : $('.press-link'),
  pressC  : $('.press-container'),
  index   : {
    points: $('.our-story-brands-section .carousel-index-point'),
  }
};

var _story = {
  press: $story.pressC.css('background-color'),
  init: function() {
    if (w <= 1024) {
      $story.brands.slick({
        arrows: false,
      });
    } else {
      setInterval(function() {
        _story.tagline();
      }, 15);
    }
  },

  tagPos: 1000,
  tagline: function() {
    if (parseInt($story.tagline.css('left')) < ((-1) * parseInt($story.tagline.width()) - 100)) _story.tagPos = 1000;
    $story.tagline.css('left', (_story.tagPos / 10) + '%');
    _story.tagPos = _story.tagPos - 5;
  },
};

$story.press.hover(function() {
  if (w > 1024) {
    var press = $(this).data('press');
    var color = $(this).data('color');
    $story.pressC.css('background-color', color);
    $('.press-content[data-press="' + press + '"]').addClass('active');
  }
}, function() {
  if (w > 1024) {
    var press = $(this).data('press');
    $story.pressC.css('background-color', _story.press);
    $('.press-content[data-press="' + press + '"]').removeClass('active');
  }
});

$story.index.points.click(function() {
  var carousel  = $(this).data('carousel');
  var index     = $(this).index('.carousel-index[data-carousel="' + carousel + '"] .carousel-index-point');
  
  $story[carousel].slick('slickGoTo', index);
});

$story.brands.on('beforeChange', function(event, slick, current, next) {
  $story.index.points.removeClass('active').eq(next).addClass('active');
});

$win.on('scroll', function() {
  if (csm.template == 'page.our-story') {
    $story.brand.each(function() {
      if ($(this).offset().top < $(document).scrollTop() + h) $(this).removeClass('inactive');
    });
  }
});

$(document).ready(function() {
  if (csm.template == 'page.our-story') {
    _story.init();
    _nav.color('black', 'black');

    $('.full-height').each(function() {
      if (!($(this).hasClass('brand-container') && w < 1024)) $(this).height(h - parseInt($(this).css('padding-top')) - parseInt($(this).css('padding-bottom')));
    });

    outerColor.text = 'black';
    outerColor.logo = 'black';
  }
});
var $product = {
  breadcrumbs : $('.product-breadcrumbs'),
  container   : $('.product-container'),
  images      : $('.product-images'),
  image       : $('.product-image'),
  related     : $('.related-products').not('.csm-recommendations .related-products'),
  add         : $('.product-add'),
  info        : $('.product-information'),
  compare     : $('.product-compared-price'),
  price       : $('.product-price'),
  variant     : $('.variant-option'),
  low         : $('.low-stock'),
  index       : {
    points  : $('.product-container .carousel-index-point'),
    images  : $('.product-container .carousel-index-point[data-carousel="images"]'),
    related : $('.product-container .carousel-index-point[data-carousel="related"]')
  },
};

var _product = {
  mobile: (csm.template == 'product') ? $(document).height() - $footer.outerHeight() - $product.add.outerHeight() - $(window).height() : null,
  desktop: (csm.template == 'product') ? $product.image.last().offset().top + $product.image.last().height() - $product.info.outerHeight() - $product.breadcrumbs.outerHeight() - parseInt($product.container.css('padding-top')) + 60 : null,

  init: function() {
    _collection.size();
    if (w <= 1024) {
      $product.images.slick({
        arrows: false,
      });
      $product.related.slick({
        arrows: false,
      });
    }
  },
};

var $a2c = {
  button  : $('.add-to-cart'),
};

var _a2c = {
  cartQuantities: {},
  busy: false,
  selected: function() { return String($a2c.button.attr('data-variant') || ''); },
  inStock: function(id) {
    var el = $('.variant-option[data-variant="' + id + '"]');
    var available = el.length ? el.attr('data-csm-available') === 'true' : $a2c.button.attr('data-csm-initial-available') === 'true';
    var policy = el.length ? el.attr('data-csm-policy') : $a2c.button.attr('data-csm-initial-policy');
    if (!available) return false;
    if (policy === 'continue') return true;
    var qty = Number(el.length ? el.attr('data-inventory') : $a2c.button.attr('data-csm-original-inventory'));
    return qty > (this.cartQuantities[id] || 0);
  },
  update: function() {
    if (this.busy) return;
    var id = this.selected();
    var ok = !!id && this.inStock(id);
    $a2c.button.removeClass('added error').toggleClass('add',ok).toggleClass('oos',!ok).prop('disabled',!ok).attr('aria-disabled',String(!ok));
    var el = $('.variant-option[data-variant="' + id + '"]');
    var qty = Number(el.length ? el.attr('data-inventory') : $a2c.button.attr('data-csm-original-inventory'));
    $product.low.toggleClass('active',ok && qty - (this.cartQuantities[id] || 0) === 1);
  },
  refresh: function() {
    var self = this;
    return $.getJSON('/cart.js').done(function(cart) {
      self.cartQuantities = {};
      (cart.items || []).forEach(function(item) {
        var id = String(item.variant_id || item.id);
        self.cartQuantities[id] = (self.cartQuantities[id] || 0) + item.quantity;
      });
      self.update();
    });
  },
  init: function() {
    $a2c.button.attr('data-csm-original-inventory',$a2c.button.attr('data-inventory'));
    this.update();
    this.refresh();
    $(window).on('pageshow focus',function() { _a2c.refresh(); });
  },
  add: function(id) {
    if (this.busy || !this.inStock(String(id))) { this.update(); return; }
    var self = this;
    this.busy = true;
    $a2c.button.prop('disabled',true);
    $.ajax({type:'POST',url:'/cart/add.js',data:{quantity:1,id:id},dataType:'json'})
      .done(function() {
        $a2c.button.removeClass('add oos').addClass('added');
        _cart.update();
        self.refresh().always(function() {
          setTimeout(function() { self.busy = false; self.update(); },1200);
        });
      })
      .fail(function() {
        $a2c.button.removeClass('add').addClass('error');
        self.refresh().always(function() {
          setTimeout(function() { self.busy = false; self.update(); },2500);
        });
      });
  }
};

$('.product-text-option').click(function() {
  $('.product-text-option, .product-text-container').removeClass('active');
  $(this).addClass('active');

  var option = $(this).data('option');
  $('.product-text-container[data-option="' + option + '"]').addClass('active');
});

$product.index.points.click(function() {
  var carousel  = $(this).data('carousel');
  var index     = $(this).index('.carousel-index[data-carousel="' + carousel + '"] .carousel-index-point');
  
  $product[carousel].slick('slickGoTo', index);
});

$product.images.on('beforeChange', function(event, slick, current, next) {
  $product.index.images.removeClass('active').eq(next).addClass('active');
});

$product.related.on('beforeChange', function(event, slick, current, next) {
  $product.index.related.removeClass('active').eq(next).addClass('active');
});

$product.variant.click(function() {
  $a2c.button.data({
    'inventory' : $(this).data('inventory'),
    'variant'   : $(this).data('variant'),
  }).attr({
    'data-inventory' : $(this).data('inventory'),
    'data-variant'   : $(this).data('variant'),
  });
  _a2c.update();

  $product.price.html('$' + (Math.floor(parseInt($(this).data('price')) / 100)));
  $('.mobile-price').html('$' + (Math.floor(parseInt($(this).data('price')) / 100)));
  if ($(this).data('compare') && parseInt($(this).data('compare')) > parseInt($(this).data('price'))) {
    $product.compare.html('$' + (Math.floor(parseInt($(this).data('compare')) / 100))).addClass('active');
    $('.mobile-compare').html('$' + (Math.floor(parseInt($(this).data('compare')) / 100))).addClass('active');
  } else {
    $product.compare.removeClass('active');
    $('.mobile-compare').removeClass('active');
  }
  
});

$a2c.button.click(function() {
  if (!$(this).prop('disabled') && !$(this).hasClass('error')) _a2c.add($(this).attr('data-variant'));
});

$(document).ready(function() {
  if (csm.template == 'product') {
    _product.init();
    _a2c.init();
  }
});

$(window).scroll(function() {

  if (csm.template == 'product') {
    if (w > 1024) {
      $product.add.fadeIn(t);

      if ($(document).scrollTop() > 80) {
        $product.info.addClass('fixed-top');

        var imageTop = $product.image.last().offset().top + $product.image.last().height() - $product.info.outerHeight();
        if ($(document).scrollTop() >= imageTop - 60) {
          $product.info.removeClass('fixed-top').css('top', imageTop);
        } else {
          $product.info.addClass('fixed-top').css('top', '60px');
        }
      } else {
        $product.info.removeClass('fixed-top').removeAttr('style');
        $('.product-header').removeClass('header-active');
      }
    } else {
      if ($(document).scrollTop() > _product.mobile) {
        $product.add.fadeOut(t);
      } else {
        $product.add.fadeIn(t);
      }
    }
  }
});

$(window).on('resize', function() {
  _product.mobile   = $(document).height() - $footer.outerHeight() - $product.add.outerHeight() - $(window).height();
});

$(window).on('load', function() {
  _product.mobile   = $(document).height() - $footer.outerHeight() - $product.add.outerHeight() - $(window).height();
});

document.addEventListener("touchmove", ScrollStart, false);
document.addEventListener("scroll", Scroll, false);

function ScrollStart() {
  setTimeout(function() {
    var menuColor = document.querySelector(".menu-link:first-child").style.color;
    document.querySelector(".ly-custom-1000 a span").style.color = menuColor;
    document.querySelector(".ly-custom-1000 a:last-child span").style.color = menuColor;
    document.querySelector(".ly-custom-0 a span").style.color = menuColor;
    document.querySelector(".ly-custom-0 a:last-child span").style.color = menuColor;
  },200);
}

function Scroll() {
  setTimeout(function() {
    var menuColor = document.querySelector(".menu-link:first-child").style.color;
    document.querySelector(".ly-custom-1000 a span").style.color = menuColor;
    document.querySelector(".ly-custom-1000 a:last-child span").style.color = menuColor;
    document.querySelector(".ly-custom-0 a span").style.color = menuColor;
    document.querySelector(".ly-custom-0 a:last-child span").style.color = menuColor;
  },200);
}
